import { render, staticRenderFns } from "./NotificationsElement.vue?vue&type=template&id=44c2d4f6&scoped=true"
import script from "./NotificationsElement.vue?vue&type=script&lang=js"
export * from "./NotificationsElement.vue?vue&type=script&lang=js"
import style0 from "./NotificationsElement.vue?vue&type=style&index=0&id=44c2d4f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c2d4f6",
  null
  
)

export default component.exports